require('./jquery/passive-scroll');

var $header = $('.main-header');
var $navigation = $('.main-navigation');

var lockPosition;

function updateSize() {
	lockPosition = $header.outerHeight() - $navigation.outerHeight();
}

function checkFixed() {
	var scrollTop = $(window).scrollTop();
	$header.toggleClass('main-header--fixed', scrollTop > lockPosition);
}

var resizeTimer;
$(window).on('resize.navigation', function() {
	clearTimeout(resizeTimer);

	resizeTimer = setTimeout(updateSize, 50);
});

updateSize();

if (Modernizr.csspositionsticky) {
	// use passive scroll. It's not bad, if the logo appears a bit too late.
	$(window).on('scroll.navigation', {passive: true}, checkFixed);
} else {
	$(window).on('scroll.navigation', checkFixed);
}
